export const TIMELINE_COMMAND_ID = 'go-to-timeline-command';
export const BACKLOG_COMMAND_ID = 'go-to-backlog-command';
export const BOARD_COMMAND_ID = 'go-to-board-command';
export const REPORTS_COMMAND_ID = 'go-to-reports-command';
